import React from 'react';
import { cn } from '@/lib/utils';

export const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'px-6 py-4 border-t border-slate-200 dark:border-slate-800',
        'bg-slate-50 dark:bg-slate-800/50 rounded-b-lg',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);

CardFooter.displayName = 'CardFooter';
